import { DEFAULT_SORT } from "@anaconda/core/nft/search/constants"
import { atom } from "@reatom/core"
import { molecule } from "bunshi"
import { NftSearchScope } from "../scope"

export const NftSortMoleculeReatom = molecule((_, scope) => {
  const { sort } = scope(NftSearchScope)

  const sortAtom = atom(sort ?? DEFAULT_SORT, "nftSort")

  return {
    sortAtom,
  }
})
